export default __webpack_public_path__ + "static/property-decription-map-m-82b1953e61c340952b5218ccdb9307ae.jpg";